export default {"src":"/_next/static/media/sushi.55d07c66.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};